// extracted by mini-css-extract-plugin
export var chevron = "_gc-4";
export var chevronExpanded = "_gc-5";
export var row = "_gc-0";
export var rowBody = "_gc-6";
export var rowDescription = "_gc-7";
export var rowHeader = "_gc-1";
export var rowTitle = "_gc-2";
export var rowTitleComplete = "_gc-3";